import React from 'react';
import { fmtQ } from '@/components/po/PoLinePicker';

const Bar = ({ pct }) => (
  <div className="h-1.5 w-full rounded-full bg-gray-200 overflow-hidden">
    <div className={`h-full ${pct >= 100 ? 'bg-emerald-500' : pct >= 50 ? 'bg-blue-500' : 'bg-amber-500'} transition-[width] duration-500`} style={{ width: `${Math.min(pct, 100)}%` }} />
  </div>
);

const slug = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-');
const plural = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`;

/** One card per section — ordered / received / pending per unit, lines past the delivery date. Click to filter. */
export const SectionSummary = ({ summary, active, onPick }) => {
  const bySection = summary.reduce((m, s) => ({ ...m, [s.section_name]: [...(m[s.section_name] || []), s] }), {});
  const names = Object.keys(bySection);
  if (!names.length) return null;
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-testid="po-pending-summary">
      {names.map((name) => {
        const rows = bySection[name];
        const late = rows.reduce((t, r) => t + r.late_lines, 0);
        const on = active === name;
        return (
          <button key={name} type="button" onClick={() => onPick(on ? 'all' : name)} data-testid={`po-summary-${slug(name)}`}
            className={`text-left rounded-lg border bg-white p-3 transition-[border-color,box-shadow] duration-150 hover:border-blue-400 ${on ? 'border-blue-600 ring-1 ring-blue-600' : 'border-gray-200'}`}>
            <div className="flex items-center justify-between gap-2">
              <span className="font-semibold text-gray-900 truncate">{name}</span>
              <span className="text-[11px] text-gray-500 shrink-0">{plural(Math.max(...rows.map((r) => r.po_count)), 'PO')} · {plural(rows.reduce((t, r) => t + r.lines, 0), 'line')}</span>
            </div>
            {rows.map((r) => (
              <div key={r.unit} className="mt-2" data-testid={`po-summary-${slug(name)}-${r.unit}`}>
                <div className="flex items-baseline justify-between text-xs tabular-nums">
                  <span className="text-gray-600">{fmtQ(r.received_qty)} / {fmtQ(r.ordered_qty)} {r.unit}</span>
                  <span className="font-bold text-amber-700">{fmtQ(r.balance_qty)} pending</span>
                </div>
                <Bar pct={r.pct_received} />
              </div>
            ))}
            {late > 0 && <p className="mt-2 text-[11px] font-medium text-rose-700" data-testid={`po-summary-${slug(name)}-late`}>{late} line{late > 1 ? 's' : ''} past the delivery date</p>}
          </button>
        );
      })}
    </div>
  );
};
